import { nav } from "src/global";

export const userAgent = nav.userAgent.toLowerCase();
export const isMobile = /mobile|iphone|iPod|ipad|android|ios/.test(userAgent);
